import { Building2 } from "lucide-react";
import type { AppInfo } from "@/shared/apps";

// Where the app sits in the shell: its tabs, "+ New" entries, settings and first steps.
export const app: AppInfo = {
  key: "directory",
  icon: Building2,
  // Customers, suppliers and products serve the apps that sell, buy or talk to customers.
  shownWith: ["crm", "invoicing", "helpdesk", "inventory", "projects"],
  tabs: [
    { to: "/organizations?type=customers", label: "nav.customers", perm: ["core.organization.read"] },
    { to: "/organizations?type=suppliers", label: "nav.suppliers", perm: ["core.organization.read"] },
    { to: "/contacts", label: "nav.contacts", perm: ["core.contact.read"] },
    { to: "/products", label: "nav.products", perm: ["core.product.read"] },
  ],
  create: [
    { label: "create.organization", to: "/organizations?new=1", perm: "core.organization.create" },
    { label: "create.product", to: "/products?new=1", perm: "core.product.create" },
  ],
};
